import { Cliente } from "../../pages/cliente/Cliente";

const cadastroClienteRoute = {
  path: "/cadastro/cliente/",
  name: "Cadastro de Cliente",
  component: Cliente,
};

export default cadastroClienteRoute;
